import {
  makeMapStateToProps,
  makeMapDispatchToProps,
  StateProps,
  DispatchProps,
  ContainerProps,
} from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { withExchangeBetslipContext, type ExchangeBetslipContext } from "../../context/exchange";
import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { ComponentProps } from "./props";

export default withExchangeBetslipContext(
  ({ localization, currencyDetails, capabilities }: ExchangeBetslipContext) => ({
    localization,
    currencyDetails,
    capabilities,
  }),
)(
  createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps, BetslipApplicationState>(
    makeMapStateToProps,
    makeMapDispatchToProps,
  ),
);
